import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {DropDownButton as DXDropDownButton} from 'devextreme-react';
import ReactDOM from "react-dom";


export default class DropDownButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // disabled: this.props.disabled,
            // visible: this.props.visible,
            selectedItemKey: this.props.selectedItemKey,
            opened: this.props.opened,
            text: this.props.text,
            // selectedItem: this.props.selectedItem
        };

        this.onItemClick = this.onItemClick.bind(this);
        this.onOptionChanged = this.onOptionChanged.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.dropDownContentTemplate = this.dropDownContentTemplate.bind(this);
        this.itemTemplate = this.itemTemplate.bind(this);
    }

    dropDownContentTemplate(template_id) {
        var tmpl = window[template_id];
        return function(itemData, itemIndex, element) {
            ReactDOM.render(tmpl(itemData), element);
        }
    }

    itemTemplate(template_id) {
        var tmpl = window[template_id];
        return function(itemData, itemIndex, element) {
            ReactDOM.render(tmpl(itemData), element);
        }
    }

    onItemClick(e) {

    }

    onOptionChanged(e) {
        if (e.name === 'opened') {
            this.setState({opened: !this.state.opened});
        }
    }

    onSelectionChanged(e) {
        this.setState({
            selectedItemKey: e.item[this.props.keyExpr],
            text: e.text,
            // selectedItem: e.item
        });

        const {setProps} = this.props;

        if (setProps) {
            setProps({
                selectedItemKey: e.item[this.props.keyExpr],
                selectedItem: e.item
            });
        }
    }

    render() {
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }

        let {dropDownContentTemplate, itemTemplate} = this.props;

        if (dropDownContentTemplate && typeof dropDownContentTemplate === 'string' && dropDownContentTemplate !== 'content'){
            dropDownContentTemplate = this.dropDownContentTemplate(dropDownContentTemplate);
        }

        if (itemTemplate && typeof itemTemplate === 'string' && itemTemplate !== 'item'){
            itemTemplate = this.itemTemplate(itemTemplate);
        }

        return (
            <DXDropDownButton
                {...omit(['loading_state', 'setProps'], this.props)}
                {...dataAttributes}
                // onItemClick={this.props.onItemClick || this.onItemClick}
                onOptionChanged={this.props.onOptionChanged || this.onOptionChanged}
                onSelectionChanged={this.props.onSelectionChanged || this.onSelectionChanged}
                opened={this.state.opened}
                selectedItemKey={this.state.selectedItemKey}
                text={this.state.text}
                dropDownContentTemplate={dropDownContentTemplate}
                itemTemplate={itemTemplate}
            />
        )
    }
}

DropDownButton.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    /**
     * Specifies the shortcut key that sets focus on the UI component
     */
    accessKey: PropTypes.string,
    /**
     * Specifies whether or not the UI component changes its state when interacting with a user
     */
    activeStateEnabled: PropTypes.bool,
    /**
     * Provides data for the drop-down menu
     */
    dataSource: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
    /**
     * Specifies whether to wait until the drop-down menu is opened the first time to render its content
     */
    deferRendering: PropTypes.bool,
    /**
     * Specifies whether the UI component responds to user interaction
     */
    disabled: PropTypes.bool,
    /**
     * Specifies the data field whose values should be displayed in the drop-down menu
     */
    displayExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * An alias for the dropDownContentTemplate property specified in React. Accepts a custom component.
     */
    dropDownContentComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * An alias for the dropDownContentTemplate property specified in React. Accepts a rendering function.
     */
    dropDownContentRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Specifies custom content for the drop-down field
     */
    dropDownContentTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * Configures the drop-down field
     */
    dropDownOptions: PropTypes.object,
    /**
     * Specifies the global attributes to be attached to the UI component's container element
     */
    elementAttr: PropTypes.object,
    /**
     * Specifies whether users can use keyboard to focus the UI component
     */
    focusStateEnabled: PropTypes.bool,
    /**
     * Specifies the UI component's height
     */
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies text for a hint that appears when a user pauses on the UI component
     */
    hint: PropTypes.string,
    /**
     * Specifies whether the UI component changes its state when a user hovers the mouse pointer over it
     */
    hoverStateEnabled: PropTypes.bool,
    /**
     * Specifies the button's icon
     */
    icon: PropTypes.string,
    /**
     * An alias for the itemTemplate property specified in React. Accepts a custom component.
     */
    itemComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * An alias for the itemTemplate property specified in React. Accepts a rendering function.
     */
    itemRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Provides drop-down menu items
     */
    items: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.object)]),
    /**
     * Specifies a custom template for drop-down menu items
     */
    itemTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * Specifies which data field provides keys used to distinguish between the selected drop-down menu items
     */
    keyExpr: PropTypes.string,
    /**
     * Specifies text or HTML markup displayed in the drop-down menu when it does not contain any items
     */
    noDataText: PropTypes.string,
    /**
     * A function that is executed when the button is clicked or tapped. If splitButton is true, this function is executed for the action button only.
     */
    onButtonClick: PropTypes.func,
    /**
     * A function that is executed when the UI component's content is ready and each time the content is changed
     */
    onContentReady: PropTypes.func,
    /**
     * A function that is executed before the UI component is disposed of
     */
    onDisposing: PropTypes.func,
    /**
     * A function used in JavaScript frameworks to save the UI component instance
     */
    onInitialized: PropTypes.func,
    /**
     * A function that is executed when a drop-down menu item is clicked
     */
    onItemClick: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    /**
     * A function that is executed after a UI component property is changed
     */
    onOptionChanged: PropTypes.func,
    /**
     * A function that is executed when an item is selected or selection is canceled. In effect when useSelectMode is true.
     */
    onSelectionChanged: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    /**
     * Specifies whether the drop-down menu is opened
     */
    opened: PropTypes.bool,
    /**
     * Switches the UI component to a right-to-left representation
     */
    rtlEnabled: PropTypes.bool,
    /**
     * Contains the selected item's data. Available when useSelectMode is true. Read only.
     */
    selectedItem: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
    /**
     * Contains the selected item's key and allows you to specify the initially selected item. Applies when useSelectMode is true.
     */
    selectedItemKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /**
     * Specifies whether the arrow icon should be displayed
     */
    showArrowIcon: PropTypes.bool,
    /**
     * Specifies whether to split the button in two: one executes an action, the other opens and closes the drop-down menu
     */
    splitButton: PropTypes.bool,
    /**
     * Specifies how the button is styled
     */
    stylingMode: PropTypes.string,
    /**
     * Specifies the number of the element when the Tab key is used for navigating
     */
    tabIndex: PropTypes.number,
    /**
     * Specifies the button's text. Applies only if useSelectMode is false.
     */
    text: PropTypes.string,
    /**
     * Specifies whether the UI component stores the selected drop-down menu item
     */
    useSelectMode: PropTypes.bool,
    /**
     * Specifies whether the UI component is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the UI component's width
     */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies whether text that exceeds the drop-down list width should be wrapped
     */
    wrapItemText: PropTypes.bool,

    // Dash-assigned callback that gets fired when the value changes.
    setProps: PropTypes.func,
    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
};

DropDownButton.defaultProps = {
    accessKey: null,
    activeStateEnabled: false,
    dataSource: null,
    deferRendering: true,
    disabled: false,
    displayExpr: 'this',
    dropDownContentComponent: null,
    dropDownContentRender: null,
    dropDownContentTemplate: 'content',
    dropDownOptions: {},
    elementAttr: {},
    focusStateEnabled: true,
    // height: undefined,
    // hint: undefined,
    hoverStateEnabled: true,
    // icon: undefined,
    itemComponent: null,
    itemRender: null,
    items: null,
    itemTemplate: 'item',
    keyExpr: 'this',
    noDataText: 'No data to display',
    onButtonClick: null,
    onContentReady: null,
    onDisposing: null,
    onInitialized: null,
    onItemClick: null,
    onOptionChanged: null,
    onSelectionChanged: null,
    opened: false,
    rtlEnabled: false,
    selectedItemKey: 1,
    showArrowIcon: true,
    splitButton: false,
    stylingMode: 'text',
    tabIndex: 0,
    text: '',
    useSelectMode: true,
    visible: true,
    // width: undefined,
    wrapItemText: false,
};

// export default Button;
